var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(475.65 -389.16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pdf-file",
    d: "M-460.98,389.16h-10v4.33h1.11v-3.2h7.22v3.93h3.89v11.81h-11.11v-1.62h-1.11v2.75h13.33V392.54Zm2.22,3.94h-2.78v-2.81h.1l2.68,2.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdf-file",
    d: "M-471.47,397.03a2.161,2.161,0,0,0-1.56-.53h-2.58v5.72h1.44v-1.91h1.34a1.806,1.806,0,0,0,1.93-1.87A1.859,1.859,0,0,0-471.47,397.03Zm-1.65,2.16h-1.05v-1.5h1.05a.711.711,0,0,1,.8.74A.725.725,0,0,1-473.12,399.19Z",
    transform: "translate(-0.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdf-file",
    d: "M-467.95,396.5h-2.44v5.72h2.35a2.772,2.772,0,0,0,1.74-.52,2.786,2.786,0,0,0,.99-2.3A2.622,2.622,0,0,0-467.95,396.5Zm-.19,4.53h-.84v-3.34h.85c.89,0,1.39.67,1.39,1.71S-467.22,401.03-468.14,401.03Z",
    transform: "translate(-0.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdf-file",
    d: "M-463.33,397.69v1.16h2.37V400h-2.37v2.22h-1.42V396.5h4.25v1.19Z",
    transform: "translate(-0.04)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-file.9b021f562636798d37b3c933902f6b09.svg";